import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    currentClinic: null,
}

const consultantSlice = createSlice({
    name: "consultant",
    initialState,
    reducers: {
        updateCurrentClinic: (state, action) => {
            console.log(action.payload, "sdlkfjdlkfjdslk")
            state.currentClinic = action.payload
        },
    },
})

export const { updateCurrentClinic } = consultantSlice.actions

export default consultantSlice.reducer
